// Single source of truth for bookable time slots (Australia/Brisbane local time).
// Displayed in the public BookingModal and mirrored in the admin Availability panel.
export const BOOKING_SLOTS = [
  "10:00",
  "10:30",
  "11:00",
  "11:30",
  "12:00",
  "12:30",
  "13:00",
  "13:30",
];

// Convert "HH:mm" (24h) → "h[:mm]am/pm" display label.
export const formatSlot = (t) => {
  const [hh, mm] = t.split(":").map(Number);
  const period = hh >= 12 ? "pm" : "am";
  const h12 = ((hh + 11) % 12) + 1;
  return mm === 0 ? `${h12}${period}` : `${h12}:${String(mm).padStart(2, "0")}${period}`;
};

// Merge default slots with admin-added custom times (deduped, chronological).
export const mergeSlots = (customTimes = []) =>
  Array.from(new Set([...BOOKING_SLOTS, ...customTimes])).sort();
